import { Outlet } from 'react-router-dom';

import Header from '@components/Header/Header';
import Footer from '@components/Footer/Footer';

import styles from './Util.module.scss';

const UtilLayout = () => {
    return (
        <div className={styles['util-layout']}>
            <Header />
            <div className={styles.body}>
                <Outlet />
                <Footer />
            </div>
        </div>
    );
};

export default UtilLayout;
